import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export interface OpMountableFrameElement extends HTMLElement {
  'product-uid': string;
  'bundled-product-uid': string;
}

const OpMountableFrame = createWrapper<OpMountableFrameElement>('op-mountable-frame');

export default OpMountableFrame;
